export const environment = {
  main_country: 'AU',
  main_brand: 'ZOOM',
  know_countries:  [
    {code: 'AU', name: 'Australia'}
  ],
  known_languages: ['en'],
  current_language: 'en',
  currency: 'AUD',
  shop_vat_rate: 0.10, // AUSTRALIA VAT

  zoom_guide_available: false,
  sonicare_available: false,
  assets_available: false,
  ftu_available: false,
  allow_reception: false,
  allow_students: false,
  allow_other_free_prod: true,

  BASE_URL: 'https://dentalshop-au.appspot.com',
  DEV_BASE_URL: 'https://beta-9-0-dot-dentalshop-au.appspot.com',
  ADMIN_BASE: 'https://beta-8-2-admin-dot-dentalshop-au.appspot.com', // NOT NEEDED ANYMORE ?
  LOCAL_BASE_URL: 'http://localhost:8877',

  NAMESPACE: 'PHILIPSDENTALPRO',
  DEV_NAMESPACE: 'PHILIPSDENTALPRO-TST',
  LOCAL_NAMESPACE: 'TST',

  send_token_in_request: true,
  // ADMIN settings
  active_app: 'Philips Dental Shop AUSTRALIA',
  app_logo: 'assets/imgs/philips.png', // TODO: use absolute URL ...
  app_bg_color: '#0073b4',
  app_favicon: 'https://philips-dentalcare.com/favicon.ico',
  menu_items: [
        {
          label: 'Dashboard',
          icon: 'fa-tachometer',
          routerLink: 'dashboard'
        },
        {
          label: 'New orders',
          icon: 'fa-cart-arrow-down',
          routerLink: 'orders/new'
        },
        {
          label: 'Archive',
          icon: ' fa-archive',
          routerLink: 'orders/archive'
        },
        {
          label: 'Products',
          icon: 'fa-list',
          routerLink: 'products'
        },
        {
          label: 'Translations',
          icon: 'fa-book',
          routerLink: 'translations'
        }
    ],
  production: false
};



// WEBPACK FOOTER //
// /Users/matthijs/projects/LC/lc-app-dashboard/src/environments/environment.au.ts